import { render, staticRenderFns } from "./emptyModule.vue?vue&type=template&id=0a1f84b5&scoped=true&"
import script from "./emptyModule.vue?vue&type=script&lang=js&"
export * from "./emptyModule.vue?vue&type=script&lang=js&"
import style0 from "./emptyModule.vue?vue&type=style&index=0&id=0a1f84b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1f84b5",
  null
  
)

export default component.exports